import {BackendEndpoints} from './BackendEndpoints'
import {getApiBaseFromBackendUrl} from './getApiBaseFromBackendUrl'

export const getV2BaseFromBackendUrl = (backendUrl: string): string => {
    return getApiBaseFromBackendUrl(backendUrl, BackendEndpoints.V2)
}
